import script from "./PhoneMe.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMe.vue?vue&type=script&setup=true&lang=js"

import "./PhoneMe.vue?vue&type=style&index=0&id=1a526070&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a526070"]])

export default __exports__